import React from "react";
import { Typography } from "@material-ui/core";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import useStyles from "../../../../modules/UserProfile/profileStyles/myProfileStyles";
import { useIntl } from "../../../../../_metronic/i18n/customUseIntl";
import DocumentCard from "./DocumentCard";
import { helpCenterStyles } from "../../../../../_metronic/layout";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GettingStarted: React.FC = () => {
  const classes = useStyles();
  const specificClasses = helpCenterStyles();
  const intl = useIntl();

  type Documents = {
    id: `SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.${string}`;
    documents: Document[];
  };

  type Document = {
    name: `${string}.pdf`;
    url: `https://${string}`;
    size: `${string} KB`;
  };

  const documents: Documents[] = [
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.RELEASES",
      documents: [
        {
          name: "My Feeds Release March 2026.pdf",
          size: "1500 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/My%20Feeds%20release%20March%202026.pdf",
        },
        {
          name: "My Ingredients release April 2026.pdf",
          size: "1216 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/My%20Ingredients%20release%20April%202026.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.DAIRY",
      documents: [
        {
          name: "Sustell Onboarding Handbook Dairy V1.0.pdf",
          size: "15409 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL_Onboarding%20Handbook_Dairy_V1.0%20.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.BEEF",
      documents: [
        {
          name: "Sustell Onboarding Handbook Beef.pdf",
          size: "15503 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL_Onboarding%20Handbook_Beef.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.SHRIMP",
      documents: [
        {
          name: "Sustell Onboarding Handbook Shrimp V1.0.pdf",
          size: "6435 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL_Onboarding%20Handbook_Shrimp_v1.0.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.POULTRY",
      documents: [
        {
          name: "Sustell Poultry Module Update Description.pdf",
          size: "158 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20poultry%20module%20update%20description.pdf",
        },
        {
          name: "Sustell Onboarding Handbook Poultry V1.0.pdf",
          size: "17427 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL_Onboarding%20Handbook_Poultry_V1.0.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.PIG",
      documents: [
        {
          name: "Sustell Pig Module Update Description July 2023.pdf",
          size: "150 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20pig%20module%20update%20description_July%202023%20(1).pdf",
        },
        {
          name: "Sustell Pig Module Update Instructions July 2023.pdf",
          size: "2716 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20Pig%20Module%20Update%20Instructions_July%202023%20(1).pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.MARINE_FISH",
      documents: [
        {
          name: "Sustell Marine Fish Module Update Description.pdf",
          size: "136 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20marine%20fish%20module%20update%20description.pdf",
        },
        {
          name: "Sustell Onboarding Handbook Marine Fish V1.0.pdf",
          size: "10062 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL_Onboarding%20Handbook_Marine%20Fish_v1.0.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.DASHBOARD",
      documents: [
        {
          name: "Sustell Business Insights Dashboard information V1.0.pdf",
          size: "1124 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20Business%20Insights%20Dashboard%20information%20v1.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.PROXY_INGREDIENT_SELECTION",
      documents: [
        {
          name: "Sustell Automated Proxy Ingredient Selection.pdf",
          size: "1246 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/Sustell%20Automated%20Proxy%20Ingredient%20Selection.pdf",
        },
      ],
    },
    {
      id: "SUSTELL.HELP_CENTER.TAB.KNOWLEDGE_BASE.GETTING_STARTED.PROCESSING",
      documents: [
        {
          name: "Sustell Onboarding Handbook for Processing V1.0.pdf",
          size: "3505 KB",
          url: "https://www.dsm-firmenich.com/content/dam/dsm/sustell/documents/SUSTELL%20Onboarding%20Handbook%20for%20Processing%20v1.pdf",
        },
      ],
    },
  ];

  return (
    <div className={classes.profileSubContainer}>
      {documents.map(({ id, documents }) => (
        <>
          <Typography className={specificClasses.gettingStartedSectionTitle}>
            {intl.formatMessage({ id })}
          </Typography>
          <DsmGrid className={specificClasses.gettingStartedSectionGrid}>
            {documents.map(({ name, size, url }: Document) => (
              <DocumentCard
                key={name}
                iconName="files/file-check-02"
                documentName={name}
                documentSize={size}
                url={url}
              />
            ))}
          </DsmGrid>
        </>
      ))}
    </div>
  );
};

export default GettingStarted;
